const asyncForEach = <T = any>(
  array: T[],
  callback: (item: T, next: () => void) => void,
  done?: () => void
) => {
  const runAndWait = (i: number): void => {
    if (i === array.length) {
      return done && done()
    }

    return callback(array[i], () => runAndWait(i + 1))
  }

  return runAndWait(0)
}

export default asyncForEach
